import { IsISO8601, IsOptional, Matches } from 'class-validator';

export class GetStandAlonePurchaseOrdersTotalsByMerchantDto {
  @IsOptional()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  date: string;
}
